import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UILink from 'UIComponents/link/UILink';
import { usePubSubRetrier } from 'conversations-internal-pub-sub/redux/hooks/usePubSubRetrier';
import { startPubSub } from '../actions/startPubSub';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PubSubErrorAlertText = ({
  mobile = false,
  isNetworkConnected = true
}) => {
  const {
    isRetrying,
    retry
  } = usePubSubRetrier(startPubSub);
  const message = mobile ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "conversations-inbox-ui.banners.pubSubFailure.mobileMessage"
  }) : !isNetworkConnected ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "conversations-inbox-ui.banners.pubSubFailure.networkError"
  }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "conversations-inbox-ui.banners.pubSubFailure.message"
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [message, ' ', isRetrying ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.banners.pubSubFailure.reconnecting"
    }) : /*#__PURE__*/_jsx(UILink, {
      onClick: retry,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.banners.pubSubFailure.reconnect"
      })
    })]
  });
};
PubSubErrorAlertText.displayName = 'PubSubErrorAlertText';
export default PubSubErrorAlertText;